import React from 'react';
import MiniTable from 'Components/MiniTable';
import { Column } from 'react-table';
import styles from './index.css';

type Props = {
    data: Top5ValueVolumeTableItem[];
    columns: Column<Top5ValueVolumeTableItem>[];
    dataTestId: string;
};

const TopFiveMerchantByPercentARTable = ({ data, columns, dataTestId }: Props) => {
    return <MiniTable className={styles.tableContainer} dataTestId={dataTestId} data={data} columns={columns} />;
};

export default TopFiveMerchantByPercentARTable;
